import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import ListGroup from '@vfuk/core-list-group'
import ListItem from '@vfuk/core-list-item'
import Interaction from '@vfuk/core-interaction'
import { spacing } from '@vfuk/core-mixins'

import type { StyledPartnerLinksProps } from './PartnerLinks.style.types'

export const PartnerLinks = styled(ListGroup)(
  (): FlattenSimpleInterpolation => css`
    img {
      max-width: 64px;
      max-height: 40px;
      object-fit: cover;
    }
  `,
)

export const ListItemWrapper = styled(ListItem)(
  (): FlattenSimpleInterpolation => css`
    display: flex;
  `,
)

export const InteractionWrapper = styled(Interaction)<StyledPartnerLinksProps>(
  (props: StyledPartnerLinksProps): FlattenSimpleInterpolation => {
    const { color, hoverColor } = props.footerTheme.appearance[props.appearance].partnerLink
    return css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      ${spacing('gap', 3)}
      transition: 0.4s all ease;
      color: ${color};

      &:hover {
        text-decoration: underline;
        color: ${hoverColor};
      }
    `
  },
)

export const LinksRow = styled(ListItem)(
  (): FlattenSimpleInterpolation => css`
    display: flex;
    justify-content: center;
    ${spacing('margin-top', 6)}

    &:first-child {
      ${spacing('margin-top', 0)}
    }
  `,
)

export const RowListGroup = styled(ListGroup)(
  (): FlattenSimpleInterpolation => css`
    display: flex;
  `,
)
